/** @format */

import template from './gb-notification-widget.html';
import './gb-notification-widget.scss';

export const GbNotificationWidgetComponent = {
    template,
    require: {
        gbApp: '^^',
        gbPresenter: '^^',
        gbWidget: '^^',
    },
    controller: class GbNotificationWidgetComponent {
        constructor($log, $rootScope, $gbNotificationProjectorWidget, $timeout, $ccColors, $scope, $ccRealtime) {
            'ngInject';

            this.$log = $log;
            this.$rootScope = $rootScope;
            this.$gbNotificationProjectorWidget = $gbNotificationProjectorWidget;
            this.$timeout = $timeout;
            this.$ccColors = $ccColors;
            this.$scope = $scope;
            this.$ccRealtime = $ccRealtime;

            this.$defaultNotifType = 'popout_a';
            this.showTime = 5000;
            this.notifs = [];

            this.notifStyles = {};
            this.secondaryStyles = {};

            this.popoutStyles = ['popout_a', 'popout_b'];
            this.toastStyles = ['toast_a'];
        }

        getNotifType() {
            return this.gbWidget.widget.notif_type || this.$defaultNotifType;
        }

        getAnimationStyle() {
            if (!this.gbWidget.widget || this.popoutStyles.indexOf(this.gbWidget.widget.notif_type) > -1) {
                return 'popout-notif';
            } else if (this.toastStyles.indexOf(this.gbWidget.widget.notif_type) > -1) {
                return 'toast-notif';
            }

            return 'popout-notif';
        }

        notifShowing() {
            return this.notifs.length > 0;
        }

        hideNotif() {
            this.notifs.length = 0;
        }

        showNotif(notif) {
            this.$scope.$apply(() => {
                this.hideNotif();
                this.notifs.push(notif);
            });

            if (this.showTimeout) {
                this.$timeout.cancel(this.showTimeout);
            }

            this.showTimeout = this.$timeout(() => {
                this.hideNotif();
                this.showTimeout = null;
            }, this.showTime);
        }

        shouldShow(notif) {
            switch (notif.notif_event) {
                case 'bid':
                    return !!this.gbWidget.widget.show_bid_notifications;
                case 'donation':
                    return !!this.gbWidget.widget.show_donation_notifications;
                case 'custom':
                    return !!this.gbWidget.widget.show_custom_notifications;
                case 'purchase':
                    return !!this.gbWidget.widget.show_purchase_notifications;
                default:
                    return false;
            }
        }

        setNotifListener() {
            if (this.gbApp.isEditMode()) {
                this.$rootScope.$on(this.gbApp.$notifPreviewEvent, (ev, data) => {
                    this.$log.info('Showing Preview Notification', ev, data);

                    if (data.widget === this.gbWidget.widget.uuid) {
                        this.$timeout(() => {
                            this.showNotif(data);
                        });
                    }
                });
            } else {
                this.$ccRealtime.on(this.$gbNotificationProjectorWidget.$showEvent, (ev, data) => {
                    this.$log.info('Showing Notification', ev, data);

                    if (this.shouldShow(data)) {
                        this.showNotif(data);
                    }
                });
            }
        }

        getNotifStyles() {
            this.notifStyles['background-color'] = this.gbWidget.allStyles['background-color'];
            this.notifStyles['color'] = this.gbWidget.allStyles['color'];
            this.notifStyles['border-width'] = this.gbWidget.allStyles['border-width'];
            this.notifStyles['border-style'] = this.gbWidget.allStyles['border-style'];
            this.notifStyles['border-color'] = this.gbWidget.allStyles['border-color'];

            return this.notifStyles;
        }

        getSecondaryStyles() {
            this.secondaryStyles['background-color'] = this.gbWidget.widget['notif_secondary_background_color'];
            this.secondaryStyles['color'] = this.gbWidget.widget['notif_secondary_color'];

            return this.secondaryStyles;
        }

        $onInit() {
            this.setNotifListener();
        }

        getImageStyle() {
            if (this.isImageContained()) return { 'background-size': 'contain' };

            return '';
        }

        isImageContained() {
            return this.gbWidget && this.gbWidget.widget && this.gbWidget.widget.image_contained;
        }
    },
};
